module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /home/ec2-user/Source/aws-lex-web-ui/node_modules/babel-runtime/regenerator/index.js
// module id = 520
// module chunks = 0